import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/deprecated/legacyElements/Button';
import styles from './style.module.scss';

export default class Stepper extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onKeyDown: PropTypes.func,
    max: PropTypes.number,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    max: undefined,
    onKeyDown: () => {},
    placeholder: '#',
    value: '',
  };

  increment = () => {
    const newValue = (this.props.value || 0) + 1;
    if (this.props.max && newValue > this.props.max) {
      return;
    }
    this.props.onChange({ name: this.props.name, value: newValue });
  };

  decrement = () => {
    const newValue = (this.props.value || 0) - 1;
    if (newValue < 0) return;
    this.props.onChange({ name: this.props.name, value: newValue });
  };

  onChange = (evt) => {
    const newValue = evt.target.value;
    if (newValue < 0) return;
    if (this.props.max && newValue > this.props.max) {
      return;
    }
    this.props.onChange({ name: this.props.name, value: newValue });
  };

  render() {
    return (
      <div className={`${styles.container} ${this.props.className || ''}`}>
        <Button onClick={this.decrement}>-</Button>
        <input
          name={this.props.name}
          value={this.props.value}
          type="number"
          onKeyDown={this.props.onKeyDown}
          onChange={this.onChange}
          min="0"
          max={this.props.max}
          onFocus={(e) => e.target.select()}
          placeholder={this.props.placeholder}
        />
        <Button onClick={this.increment}>+</Button>
      </div>
    );
  }
}
